/* eslint-disable react/no-danger */
import React from 'react';
import { useTranslation } from 'react-i18next';
import useOrderWsMessageData from '../../../hooks/inbox/data/useOrderWsMessageData';
import MessageStatusMC from './MessageStatusMC';
import useOrderWsMessageActions from '../../../hooks/inbox/actions/useOrderWsMessageActions';
import ImageMC from '../../../components/ImageMC';
import IconMC from '../../../components/IconMC';

const OrderWsMessageMC = React.memo(({ conversation, message, onClick }) => {
  const { data, messageText, url } = useOrderWsMessageData({ platform: conversation.platform, message });
  const { handleToggleModal, handleImageClick } = useOrderWsMessageActions({ message, onClick, url });

  // Traducciones (i18n)
  const { t } = useTranslation('InboxMC');
  const labelOutbound = t('orders.outbound');
  const labelInbound = t('orders.inbound');
  const labelDetail = t('orders.detail');

  return (
    <div className="tw-wrapper tw-p-2 tw-bg-white">
      <div className="tw-text-3xs tw-mb-2 tw-font-semibold tw-text-gray-600">
        {message.direction === 'outbound' ? labelOutbound : labelInbound}
      </div>

      <div className="tw-flex tw-items-center tw-media-caption">
        <div className="tw-p-2">
          <ImageMC
            platform={conversation.platform}
            data={data}
            onClick={handleImageClick}
            className="tw-block tw-w-full tw-h-full tw-object-cover tw-rounded-[9px] tw-bg-white tw-cursor-pointer !tw-max-w-none !tw-max-h-none"
          />
        </div>
        <div className="tw-p-2">
          {messageText && (
            <div
              className="tw-whitespace-pre-line tw-text-left tw-text-xs tw-font-sans tw-text-gray-800"
              dangerouslySetInnerHTML={{ __html: messageText }}
            />
          )}
        </div>
      </div>

      <MessageStatusMC message={message} platform={conversation.platform} />

      <div className="tw-border-b tw-p-2" />
      <div className="tw-flex tw-justify-center tw-items-center tw-pt-2">
        <button
          type="button"
          className="tw-flex tw-items-center tw-gap-2 tw-text-blue-600 tw-font-semibold tw-text-xs tw-bg-transparent hover:tw-underline focus:tw-outline-none"
          onClick={handleToggleModal}
        >
          <IconMC name="shopping-bag-outline" size="lg" />
          <span>{labelDetail}</span>
        </button>
      </div>
    </div>
  );
});

OrderWsMessageMC.displayName = 'OrderWsMessageMC';

export default OrderWsMessageMC;
